<template>
  <a-config-provider :locale="locale" :get-popup-container="popContainer">
    <router-view/>
  </a-config-provider>
</template>

<script>
import {mapState, mapMutations} from 'vuex'
import themeUtil from '@/utils/themeUtil';
import {getI18nKey} from '@/utils/routerUtil'
import moment from 'moment';
// eslint-disable-next-line no-unused-vars
import locale from 'ant-design-vue/lib/locale-provider/zh_CN';
import {enquireScreen} from './utils/util'
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

const cn = require('ant-design-vue/es/locale-provider/zh_CN')
const hk = require('ant-design-vue/es/locale-provider/zh_TW')
const us = require('ant-design-vue/es/locale-provider/en_US')

export default {
  name: 'App',
  data() {
    return {
      locale: {}
    }
  },
  computed: {
    ...mapState('setting', ['theme', 'weekMode', 'lang'])
  },
  watch: {
    weekMode(val) {
      this.setWeekModeTheme(val)
    },
    lang(val) {
      this.setLanguage(val)
      this.setHtmlTitle()
    },
    $route(router) {
      // eslint-disable-next-line no-underscore-dangle
      if (window.__POWERED_BY_WUJIE__) {
        window.$wujie.bus.$emit('sub-route-change', router);
      }
      this.setHtmlTitle()
    },
    'theme.mode': function mode(val) {
      const closeMessage = this.$message.loading(`您选择了主题模式 ${val}, 正在切换...`)
      themeUtil.changeThemeColor(this.theme.color, val).then(closeMessage)
    },
    'theme.color': function color(val) {
      const closeMessage = this.$message.loading(`您选择了主题色 ${val}, 正在切换...`)
      themeUtil.changeThemeColor(val, this.theme.mode).then(closeMessage)
    }
  },
  created () {
    this.setHtmlTitle()
    this.setLanguage(this.lang)
    enquireScreen(isMobile => this.setDevice(isMobile))
  },
  mounted() {
   this.setWeekModeTheme(this.weekMode)
    // window.addEventListener("storage", (e) => {
    //   if (e.key === 'TokenKey') {
    //     if (e.oldValue && e.newValue !== e.oldValue) {
    //       this.$info({
    //         title: '提示',
    //         content: '当前登录账号异常，请刷新重试',
    //         okText: '刷新',
    //         onOk() {
    //           window.location.reload();
    //         },
    //       });
    //     }
    //   }
    // });
  },
  methods: {
    ...mapMutations('setting', ['setDevice']),
    setWeekModeTheme(weekMode) {
      if (weekMode) {
        document.body.classList.add('week-mode')
      } else {
        document.body.classList.remove('week-mode')
      }
    },
    setLanguage(lang) {
      this.$i18n.locale = lang
      switch (lang) {
        case 'CN':
          this.locale = cn.default
          break
        case 'HK':
          this.locale = hk.default
          break
        case 'US':
        default:
          this.locale = us.default
          break
      }
    },
    setHtmlTitle() {
      const route = this.$route
      const key = route.path === '/' ? 'home.name' : getI18nKey(route.matched[route.matched.length - 1].path)
      document.title = `${process.env.VUE_APP_NAME  } | ${  this.$t(key)}`
    },
    popContainer() {
      return document.getElementById("popContainer")
    }
  }
}
</script>

<style lang="less" scoped>
  #id{
  }
</style>
